import {ABOUT_INFO_LIST,ABOUT_INFO_SUCCESS,ABOUT_INFO_ERROR } from "../../../redux/contants";

import { all, fork, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios'
import { apiBaseUrl } from '../../../constants/defaultValues';


function* fetchAboutInfoAPI() {
    
    try {
       
          const config = {
            method: 'get',
            url: `${apiBaseUrl}AboutInfo/GetAboutInfoList`,
            headers: { 
              'Accept': 'text/plain', 
              'Authorization': '<API Key>'
            }
          };
          const aboutinfodetails = yield axios(config).then(response => response.data.Data);
        
        // console.log(subscriberDetails,"============")
        yield put({ type: ABOUT_INFO_SUCCESS, data: aboutinfodetails });
    } catch (error) {
        yield put({ type: ABOUT_INFO_ERROR, error });
    }
}


export function* watchaboutinfo() {
    // eslint-disable-next-line no-use-before-define
    yield takeEvery(ABOUT_INFO_LIST, fetchAboutInfoAPI);

}

export default function* rootSaga() {
    yield all([
        fork(watchaboutinfo),
    ]);
}